import React from 'react';
import { IconProps } from '.';

const SvgColoredFire = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#F05046'
        d='M20.2 14.624c0 4.793-3.968 8.647-8.76 8.361-4.926-.294-8.298-5.03-7.663-9.982.2-1.565.676-3.013 1.304-4.325 1.106-2.313 1.921-2.014 1.847.549-.016.566.023.867.182.547 1.933-2.415 4.083-4.72 4.817-7.94.084-.372.524-.553.82-.314 2.327 1.882 7.453 6.7 7.453 13.104Z'
      />
      <path
        fill='url(#ColoredFire_svg__a)'
        d='M12.081 22.476c3.143-.524 5.238-3.134 5.238-6.286 0-3.587-2.995-5.981-4.398-6.905-.402-.265-.921-.149-1.237.215-1.999 2.304-3.183 2.264-4.632 5.643-1.047 4.19 2.934 7.333 5.029 7.333Z'
      />
      <path
        fill='#FFE17C'
        d='M14.336 19.07c-.09 1.99-1.146 3.543-2.337 3.416-1.286-.136-2.075-2.257-1.787-4.39.248-1.837 1.024-3.253 1.605-4.091.337-.486 1.003-.456 1.294.059.571 1.01 1.327 2.79 1.225 5.007Z'
      />
      <defs>
        <radialGradient
          id='ColoredFire_svg__a'
          cx={0}
          cy={0}
          r={1}
          gradientTransform='matrix(.388 -11.91668 10.7705 .35069 11.437 20.348)'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFC746' />
          <stop offset={1} stopColor='#FF6432' />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default SvgColoredFire;
